import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { StageBadge } from "@/components/Badges";
import { GitMerge, CopyPlus, SkipForward } from "lucide-react";

export const DedupDialog = ({ conflict, incoming, onResolve, onClose }) => {
  const d = conflict?.duplicate;
  return (
    <Dialog open={!!conflict} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="dedup-modal" className="border-amber-300 bg-white text-[#1A1A1A] sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display text-amber-700">Duplicate detected</DialogTitle>
          <DialogDescription className="text-neutral-500">Match on {conflict?.match_type === "EMAIL_EXACT" ? "email address" : "normalized phone (E.164)"}. Choose how to resolve.</DialogDescription>
        </DialogHeader>
        {d && (
          <div className="grid grid-cols-2 gap-3 text-sm">
            <div className="rounded-lg border border-neutral-200 p-3">
              <p className="font-mono text-[10px] uppercase tracking-wider text-neutral-400">Existing</p>
              <p className="mt-1 font-semibold">{d.full_name}</p><p className="text-neutral-500">{d.company_name || "—"}</p>
              <p className="font-mono text-xs text-neutral-500">{d.phone_e164}</p><p className="text-xs text-neutral-500">{d.email || "—"}</p>
              <div className="mt-2"><StageBadge stage={d.lifecycle_stage} /></div>
            </div>
            <div className="rounded-lg border border-[#1F9E7A]/40 p-3">
              <p className="font-mono text-[10px] uppercase tracking-wider text-[#1F9E7A]">Incoming</p>
              <p className="mt-1 font-semibold">{incoming?.full_name}</p><p className="text-neutral-500">{incoming?.company_name || "—"}</p>
              <p className="font-mono text-xs text-neutral-500">{incoming?.phone}</p><p className="text-xs text-neutral-500">{incoming?.email || "—"}</p>
            </div>
          </div>
        )}
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
          <Button data-testid="dedup-action-merge" onClick={() => onResolve("merge")} className="bg-[#1F9E7A] hover:bg-[#178566]"><GitMerge className="mr-1 h-4 w-4" />Merge</Button>
          <Button data-testid="dedup-action-secondary" variant="outline" onClick={() => onResolve("secondary")} className="border-neutral-300 bg-transparent text-neutral-800"><CopyPlus className="mr-1 h-4 w-4" />Secondary</Button>
          <Button data-testid="dedup-action-skip" variant="ghost" onClick={() => onResolve("skip")} className="text-neutral-500"><SkipForward className="mr-1 h-4 w-4" />Skip</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
